import styled from '@emotion/styled';
import React, { type FC } from 'react';
import { VisuallyHidden } from '../../../../../../ui';
import { locales } from '../../../../i18n/locale';
import { useLocale } from '../../../../i18n/locale/useLocale';
import { useTranslation } from '../../../../i18n/translate/useTranslation';
import {
	NavItemType,
	useNavigationContext,
} from '../../context/NavigationContext';
import {
	StyledMainNavListItemWrapper,
	StyledSubmenu,
} from '../../main/StyledNavigationItems';
import { StyledButtonAsLink } from '../../main/sections/StyledButtonAsLink';
import LanguageIcon from '../icons/language.svg';
import { LanguageSwitchItem } from './LanguageSwitchItem';

export interface ILanguageSwitchProps {
	className?: string;
}

export const LanguageSwitch: FC<ILanguageSwitchProps> = () => {
	const { isLangSubMenuOpen, handleNavigationItemClick } =
		useNavigationContext();

	if (locales.length <= 1) return null;

	return (
		<StyledMainNavListItemWrapper role="none">
			<LanguageNavItem />

			<StyledSubmenu
				width="max-content"
				open={isLangSubMenuOpen}
				role={isLangSubMenuOpen ? 'menu' : undefined}
				aria-hidden={!isLangSubMenuOpen}
				relativeSubMenu={false}
			>
				{isLangSubMenuOpen &&
					locales.map((locale) => (
						<StyledMainNavListItemWrapper
							id={locale.code}
							key={locale.code}
							role="none"
							onClick={() =>
								handleNavigationItemClick({
									type: NavItemType.Language,
									item: locale,
								})
							}
						>
							<LanguageSwitchItem locale={locale} />
						</StyledMainNavListItemWrapper>
					))}
			</StyledSubmenu>
		</StyledMainNavListItemWrapper>
	);
};

interface ILanguageNavItemProps {
	isMobileView?: boolean;
}

export const LanguageNavItem = ({ isMobileView }: ILanguageNavItemProps) => {
	const { t } = useTranslation();
	const currentLocale = useLocale();
	const { handleNavigationItemClick } = useNavigationContext();
	const handleLangClick = () => {
		handleNavigationItemClick({
			type: NavItemType.Language,
			item: undefined,
		});
	};

	return (
		<>
			{isMobileView ? (
				<LanguageSwitchItem
					locale={locales.filter((item) => item.code !== currentLocale.code)[0]}
				>
					<LanguageIcon />
					<VisuallyHidden as="span">
						{t('select_website_language_alt')}
					</VisuallyHidden>
				</LanguageSwitchItem>
			) : (
				<StyledButtonAsLink
					onClick={handleLangClick}
					open={false}
					role="menuitem"
				>
					<LanguageIcon />
					<VisuallyHidden as="span">
						{t('select_website_language_alt')}
					</VisuallyHidden>
				</StyledButtonAsLink>
			)}
		</>
	);
};

export const StyledImage = styled.img`
	min-width: 24px;
	width: 24px;
	height: 24px;
`;
